export default __webpack_public_path__ + "static/media/logoHeader.285579e9.svg";